<template>
  <div>
    <fileuploader
      :url="url"
      :max-filesize="maxFilesize"
      :max-files="maxFiles != null ? maxFiles - files.length : undefined"
      :accepted-files="acceptedFiles"
      :placeholder="placeholder"
      :param-name="paramName"
      :progress="uploadProgress"
      :status="uploadStatus"
      :active="uploadStatus == 'complete'"
      :append-token="appendToken"
      :file-names="fileNames"
      :error-message="errorMessage"
      :height="dropzoneHeight"
      v-on:complete="emitComplete"
      v-on:status="emitStatus"
      v-on:progress="emitProgress"
      v-on:addfile="emitAddFile"
      no-progressbar
    ></fileuploader>
    <div v-for="(file, index) in files" v-if="false">
      <template v-if="showFile(file)">
        <h3 class="filename">{{ file.name }}</h3>
        <progressbar
          :progress="file.progress"
        ></progressbar>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    files: {
      type: Array,
      default() {
        return [];
      }
    },
    uploadProgress: {
      type: Number,
      default: 0
    },
    uploadStatus: {
      type: String,
      default: 'idle'
    },
    appendToken: {
      type: Boolean,
      default: false
    },
    paramName: {
      type: String,
      default: 'attachment'
    },
    maxFilesize: {
      type: Number,
      default: 500
    },
    maxFiles: {
      type: Number,
      default: 10
    },
    url: {
      type: String
    },
    acceptedFiles: {
      type: [String, Array],
      default: ''
    },
    placeholder: {
      type: [String, Object]
    },
    fileNames: {
    },
    errorMessage: {
      type: [String, Object],
      default: null,
    },
    dropzoneHeight: {
      type: Number,
    }
  },
  methods: {
    emitComplete: function(fileuploader, file) {
      this.$emit('complete', fileuploader, file);
    },
    emitProgress(progress, file) {
      this.$emit('progress', progress, file);
    },
    emitStatus(status, file, message) {
      this.$emit('status', status, file, message);
    },
    emitAddFile(fileuploader, file) {
      this.$emit('addfile', fileuploader, file);
    },
    showFile(file) {
      return typeof file.progress == 'undefined' || file.progress < 100;
    }
  }
};
</script>
